import { useState } from 'react';

import ConsultaSalarioGerentes from '../../components/ConsultaSalarioGerentes/ConsultaSalarioGerentes';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function RemuneracaoGerentes() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive &&
            <NotifierPopup
                notify={notify}
                setNotify={setNotify}
            />
        }
        <ConsultaSalarioGerentes setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}
